import React, { Fragment } from 'react';
import './AutoMax.scss';
import { AUTOMATIC_TRANSACTION_DELETE } from '../../../redux/modules/modals/modals.module';
import { openModal } from '../../../redux/modules/modals/actions';
import { agreementTypeToProperCase } from '../../../utils/funds/funds-utility';
import { APP_TOLL_FREE_NUMBER } from '../../../settings/settings';
import { titleCase } from '../../../utils/utils';
import { automaticTipText } from '../../../utils/automatic/automatic-utils';
import If from '../../Shared/If/If';
import ToolTip from '../../Shared/ToolTip/ToolTip';
import { TOOLTIP_POSITION_BOTTOM } from '../../../utils/dom-utils';
import Phone from '../../Shared/Phone/Phone';
import { useDispatch } from 'react-redux';
import config from '../../../config/config';
import { appendBasePath } from '../../../utils/nav.utils';

const AutoMax = ({ funds, showEdit, type }) => {
  const { pendingTrade, featureStatus } = funds?.[0] || {};

  const dispatch = useDispatch();
  //TODO: temporarily disabling edit for day 1 of auto-max flow and adding in temporary div telling user to delete
  //then apply for auto-rmd
  return (
    <div>
      {showEdit && (
        <div>
          <div>
            <If test={pendingTrade && featureStatus.enumerationID === 100}>
              <div className="automax-action-container_edit">
                <ToolTip
                  message={
                    <div className="automatic-action-options-toolTip">
                      Adding a new IRA Automax may take up to three business
                      days to process. Call{' '}
                      <Phone phoneNumber={APP_TOLL_FREE_NUMBER} /> to make an
                      update.
                    </div>
                  }
                  callerText={'Pending'}
                  placement={TOOLTIP_POSITION_BOTTOM}
                />
              </div>
            </If>
            <If test={pendingTrade && featureStatus.enumerationID === 101}>
              <div className="automax-action-container_edit">
                <ToolTip
                  message={
                    <div className="automatic-action-options-toolTip">
                      Deleting an IRA Automax may take up to three business days
                      to process. Call{' '}
                      <Phone phoneNumber={APP_TOLL_FREE_NUMBER} /> to make an
                      update.
                    </div>
                  }
                  callerText={'Delete Pending'}
                  placement={TOOLTIP_POSITION_BOTTOM}
                />
              </div>
            </If>
            <If test={pendingTrade && featureStatus.enumerationID === 102}>
              <div>
                <ToolTip
                  message={automaticTipText(funds?.[0])}
                  callerText={'Update Pending'}
                  placement={TOOLTIP_POSITION_BOTTOM}
                />
              </div>
            </If>
            <If test={!pendingTrade}>
              <div className="automax-action-container_edit auto-max-buttons-containers">
                {/*<a*/}
                {/*  className="automatic-action-options-action-choice college-branded-link"*/}
                {/*  href={`${config.url}${appendBasePath(*/}
                {/*    '/automatic/ira-automax/edit'*/}
                {/*  )}`}*/}
                {/*>*/}
                {/*  Edit*/}
                {/*</a>*/}
                {/*<div className="automatic-action-options-spacer" />*/}

                <a
                  className="automatic-action-options-action-choice college-branded-link"
                  href={`${config.url}${appendBasePath(
                    '/automatic/ira-automax/edit'
                  )} `}
                >
                  Edit
                </a>
                <span className="automatic-action-options-spacer"></span>
                <a
                  className="automatic-action-options-action-choice college-branded-link"
                  onClick={() => {
                    dispatch(
                      openModal(AUTOMATIC_TRANSACTION_DELETE, {
                        fund: funds,
                        type: type,
                      })
                    );
                  }}
                >
                  Delete
                </a>
              </div>
            </If>
          </div>
          <div>
            <div className="automax-transaction-info">
              <div className="automax-label-container">
                <div className="automax-label">To:</div>
              </div>
              <div className="automax-detail-container">
                <div className="automax-status">
                  {funds.map((fund, i) => {
                    return (
                      <Fragment key={`${fund.agreementID}-${i}`}>
                        <div>
                          <div>
                            {fund.fundName} {fund.productType && fund.ticker} -{' '}
                            {agreementTypeToProperCase(fund.agreementType)}
                          </div>
                          <div className="expanded-automatic-transaction-fund-details blocked_data ">
                            {fund.agreementNumber}{' '}
                            <span>• {fund.formattedEntityNames}</span>
                          </div>
                        </div>
                      </Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="automax-transaction-info">
              <div className="automax-label-container">
                <div className="automax-label">From:</div>
              </div>
              <div className="automax-detail-container">
                {funds?.[0].bank.length > 0 && (
                  <div className="expanded-automatic-transaction-month-review blocked_data blocked_data-ira-automax">
                    {funds?.[0].bank?.[0].name} -{' '}
                    {titleCase(funds?.[0].bank?.[0].bankAccountType)}{' '}
                    <span className="blocked_data">
                      {funds?.[0].bank?.[0].accountNumber}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {!showEdit && (
        <div>
          <div className="automax-POA">
            {funds?.fullName} has an IRA AutoMax on file
          </div>
          <div className="temp-auto-max-edit-note">
            Power of Attorney accounts cannot be edited or deleted online.
          </div>
        </div>
      )}
    </div>
  );
};

export default AutoMax;
